import { render, staticRenderFns } from "./SetSysuse.vue?vue&type=template&id=0f96e34d&scoped=true"
import script from "./SetSysuse.vue?vue&type=script&lang=js"
export * from "./SetSysuse.vue?vue&type=script&lang=js"
import style0 from "./SetSysuse.vue?vue&type=style&index=0&id=0f96e34d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96e34d",
  null
  
)

export default component.exports